export default __webpack_public_path__ + "static/biz-advice-left-3faebdad22cd3f8cf3f7038757d46ac3.svg";